export const ItemChangeTypeMap = {
  0: 'Add',
  1: 'Update',
  2: 'Delete',
  3: 'Add Component',
  4: 'Delete Component',
  5: 'Update Component',
  999: 'error reading item type',
};